export default "__VITE_PUBLIC_ASSET__7af0d66d__"